import React, { useState } from 'react'
import { Col, Form, FormCheck } from 'react-bootstrap'
import { EmailOptIn, LegalModal } from '@srca-b2b/kp5-ui-common'
import { connect } from 'formik'
import PropTypes from 'prop-types'
import Link from 'next/link'
import { useTranslation } from 'next-i18next'

const AgreementFormGroup = ({ formik, name, id, label, modalLinkOverride, country }) => {
  const [show, setShow] = useState(false)
  const { t } = useTranslation('common')

  const handleShow = (event) => {
    event.preventDefault()
    setShow(true)
  }

  const setField = () => {
    formik.setFieldValue(id, true)
  }

  /**
   * This func helps return the value of the translation key.
   * Since text is passed as props to this component
   * we have tried to dynamically create translation key dynamically
   * based on the actual text value
   * @param {*} textVal
   */
  const getTranslationKey = (textVal) => {
    if (textVal) {
      return textVal.trim().substr(0, 30).replaceAll(' ', '_').concat('_text')
    } else return ''
  }

  return (
    <Form.Group as={Col} controlId={id} className="mx-auto">
      <FormCheck custom inline required>
        <FormCheck.Input
          isInvalid={formik.errors[name]}
          type={'checkbox'}
          name={name}
          id={id}
          checked={formik.values[name]}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
        />

        <FormCheck.Label htmlFor={id} className="font-weight-normal">
          {t(getTranslationKey(label?.introText))}
          {label?.modalLink?.length > 0 && (
            <>
              <>
                <Link
                  href={label.externalHref || '#'}
                  rel={'noreferrer'}
                  role={'button'}
                  onClick={label.externalHref ? null : handleShow}
                >
                  <a target={label.externalHref ? '_blank' : '_self'}>
                    {modalLinkOverride || t(getTranslationKey(label.modalLink))}
                  </a>
                </Link>
                {!label.externalHref && (
                  <LegalModal
                    agreements={[id]}
                    show={show}
                    setShow={setShow}
                    callback={setField}
                    bypassAccept={true}
                  />
                )}
              </>
            </>
          )}
          {name == 'receiveEmails' && (
            <EmailOptIn
              show={show}
              setShow={setShow}
              linkText={t('Details')}
              linkId={'ga-kp-getstarted-signin-companyinfo-agreement-detailspopup'}
              ppId={
                'ga-kp-getstarted-signin-companyinfo-agreement-detailspopup-Samsungknoxprivacypolicy'
              }
              country={country}
            />
          )}
          {id === 'privacy_consent_ko'
            ? t('consent_closing_text')
            : t(getTranslationKey(label?.closingText))}
        </FormCheck.Label>
      </FormCheck>
    </Form.Group>
  )
}

AgreementFormGroup.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.object.isRequired,
  optionText: PropTypes.string
}

export default connect(AgreementFormGroup)
